import ROUTES from 'routes/constants';

import {
  CONTRACT,
  OFFER,
  VISIT,
  DOCUMENTATION,
} from '../../enums/rentProgressTypes';
import {
  SEARCH_CONTRACT,
  SEARCH_OFFER,
  SEARCH_VISIT,
  SEARCH_DOCUMENTATION,
} from '../../enums/searchTypes';
import {
  visitHouseFetchSuccess,
  visitUserFetchSuccess,
} from '../DoneVisits/actions';
import {
  contractHouseFetchSuccess,
  contractUserFetchSuccess,
} from '../RentProgress/Contracts/actions';
import {
  documentationHouseFetchSuccess,
  documentationUserFetchSuccess,
} from '../RentProgress/Documentations/actions';
import {
  offerHouseFetchSuccess,
  offerUserFetchSuccess,
} from '../RentProgress/Offers/actions';

export const mapSearchTypeToRentProgressType = (typedKey) => {
  const rentProgressMapper = {
    [SEARCH_CONTRACT]: CONTRACT,
    [SEARCH_OFFER]: OFFER,
    [SEARCH_VISIT]: VISIT,
    [SEARCH_DOCUMENTATION]: DOCUMENTATION,
  };

  if (!([typedKey] in rentProgressMapper)) {
    return typedKey;
  }

  return rentProgressMapper[typedKey];
};

export const parseFetchHouseQuery = (typedKey) => (result) => ({
  [typedKey]: result[typedKey],
  houseId: result.houseId,
});

export const parseFetchUserQuery = (typedKey) => (result) => {
  const userKey = typedKey === 'offerId' ? 'tenantId' : 'visitorId';
  return {
    [typedKey]: result[typedKey],
    tenantId: result[userKey],
  };
};

export const getSuccessHouseActionType = (rentProgressType) => {
  switch (rentProgressType) {
    case CONTRACT:
      return contractHouseFetchSuccess;
    case OFFER:
      return offerHouseFetchSuccess;
    case VISIT:
      return visitHouseFetchSuccess;
    case DOCUMENTATION:
      return documentationHouseFetchSuccess;
    default:
      throw new Error('Invalid type provided');
  }
};

export const getSuccessUserActionType = (rentProgressType) => {
  switch (rentProgressType) {
    case CONTRACT:
      return contractUserFetchSuccess;
    case OFFER:
      return offerUserFetchSuccess;
    case VISIT:
      return visitUserFetchSuccess;
    case DOCUMENTATION:
      return documentationUserFetchSuccess;
    default:
      throw new Error('Invalid type provided');
  }
};

export const getIdFromType = (type) => {
  if (!type || !type.length) {
    throw new Error('Missing required type');
  }
  return `${type}Id`;
};

export const isUserDataLoaded = (
  {
    agentData,
    checkedAgent,

    isCheckedAgent,
    unauthorizedAgent,
  },
  user,
  location,
) => {
  const { pathname } = location;
  const { id: userId } = user;

  const isAppReady = agentData && isCheckedAgent && checkedAgent;

  return (isAppReady && userId !== 0) || unauthorizedAgent;
};
